<template>

  <div style="width: 100%;">
    <div id="myBoard" style="width: 100%"
         v-bind:style="{ display: showBoard }"></div>
    <div style="height: 5px"></div>
    <div class="grid-layout-container alignment-block">

      <vs-row vs-align="flex-end" vs-type="flex" vs-justify="center" vs-w="12" style="margin-left: -5px">


        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-arrow-left" @click="moveBack"
                   style="margin-left: 3px"></vs-button>&nbsp;
        <vs-button id="nextButton" @click="moveForward($event)" color="primary" type="filled" icon-pack="feather"
                   icon="icon-arrow-right"></vs-button>&nbsp;
        <vs-button  @click="showChapterMenu($event)" color="primary" type="border" icon-pack="feather"
                   icon="icon-list"></vs-button>&nbsp;
        <vs-button @click="flipBoard()" type="border" icon-pack="feather"
                   icon="icon-refresh-ccw"></vs-button>&nbsp;


        <span style="width: 20px">  </span>
        <vs-spacer/>
        <div style="height: 100%;padding-right: 5px">
          <span class="chess" style="height: 100%;vertical-align: top;font-weight: bold;color: black">{{lastBookMove.pgnMove}}</span>
          <span>&nbsp;</span>
          <vs-icon style="border: 1px solid black" icon="circle" size="small" :bg="color" round></vs-icon>
        </div>

        <vs-dropdown vs-trigger-click>
          <vs-button type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>

          <vs-dropdown-menu>


            <vs-dropdown-item>
              <vs-icon color="primary" class="drop-icon" icon-pack="feather" icon="icon-file-text"><span
                class="drop-item" @click="showToc()">Content</span></vs-icon>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <vs-icon color="primary" class="drop-icon" icon-pack="feather" icon="icon-toggle-left"><span
                class="drop-item" @click="hideBoard()">Board</span></vs-icon>
            </vs-dropdown-item>


            <vs-dropdown-item @click="hideEngine">
              <vs-icon color="green" class="drop-icon" icon-pack="feather" icon="icon-cpu"><span class="drop-item">Engine</span>
              </vs-icon>
            </vs-dropdown-item>


            <vs-dropdown-item divider @click="settings()">
              <vs-icon color="primary" class="drop-icon" icon-pack="feather" icon="icon-settings"><span
                class="drop-item" @click="settings()">Settings</span></vs-icon>
            </vs-dropdown-item>


          </vs-dropdown-menu>

        </vs-dropdown>


      </vs-row>
      <vs-row>
        <div class="engine" v-bind:style="{ display: showEngine }">
          <engine ref="engine" @setFen="onEngineSetFen"></engine>
        </div>
      </vs-row>
    </div>

    <vue-context ref="chooseMoveMenu">
      <li v-for="move in nextMoves" style="margin: 10px;cursor:pointer;" v-on:keyup.enter="chooseMove(move)">
        <a style="color: black;font-weight: bold; padding: 10px" class="move chess" @click="chooseMove(move)">{{
          move.pgnMove }}</a>
      </li>
    </vue-context>

    <vue-context ref="promotionMenu" style="width: 150px">
      <li style="width: 100%">
        <vs-button style="width: 100%" @click="doPromotion('q')" color="primary" type="flat"><span
          class="chess" style="font-size: xx-large">Q</span>
        </vs-button>
      </li>
      <li>
        <vs-button style="width: 100%" @click="doPromotion('r')" color="primary" type="flat"><span
          class="chess" style="font-size: xx-large">R</span>
        </vs-button>
      </li>
      <li>
        <vs-button style="width: 100%" @click="doPromotion('n')" color="primary" type="flat"><span
          class="chess" style="font-size: xx-large">N</span>
        </vs-button>
      </li>
      <li>
        <vs-button style="width: 100%" @click="doPromotion('b')" color="primary" type="flat"><span
          class="chess" style="font-size: xx-large">B</span>
        </vs-button>
      </li>
    </vue-context>

    <vs-prompt
      title="Board Settings"
      :buttons-hidden="true"
      :active.sync="activeSettings">

      <vs-row>
        <vs-col vs-type="flex" vs-w="8" class="p-4 sm:p-1">
          <div class="dropdown-button-container">
            <vs-dropdown vs-trigger-click>
              <vs-button type="border" style="font-weight: bold" icon="expand_more">{{theme.value}} board theme
              </vs-button>
              <vs-dropdown-menu style=" z-index: 55000;">
                <vs-dropdown-item class="drop-item" :key="theme.index" :id="theme.index" @click="selectTheme(index)"
                                  v-for="(theme, index) in themes">{{theme.value}}
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col vs-type="flex" vs-w="8" class="p-4 sm:p-1">
          <div class="dropdown-button-container">
            <vs-dropdown vs-trigger-click>
              <vs-button type="border" style="font-weight: bold" icon="expand_more">{{pieceTheme.value}} piece theme
              </vs-button>
              <vs-dropdown-menu style=" z-index: 55000;">
                <vs-dropdown-item class="drop-item" :key="theme.index" :id="theme.index"
                                  @click="selectPieceTheme(index)"
                                  v-for="(theme, index) in themes">{{theme.value}}
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </vs-col>
      </vs-row>
      <span style="height: 20px">&nbsp;</span>
      <vs-row>
        <vs-switch color="success" v-model="showNotation">
          <span slot="on">On</span>
          <span slot="off">Off</span>
        </vs-switch>&nbsp;<span style="font-weight: bold">board notation</span>
      </vs-row>

    </vs-prompt>

  </div>

</template>

<script>
    import {VueContext} from 'vue-context';
    import Chess from 'chess.js'
    import Chessboard from './chessboard.js'
    import {boardThemes, piecesThemes} from "./themes.js";
    var scrollIntoView = require('scroll-into-view');

    export default {
        components: {
            VueContext
        },
        name: "mychessboard",
        data() {
            return {
                color: 'white',
                showNotation: true,
                nextMoves: [],
                lastBookMove: {},
                activeSettings: false,
                theme: {index: 0, value: "default"},
                pieceTheme: {index: 0, value: "default"},
                showBoard: "block",
                showEngine: "none",
                engineButtonColor: "warning",
                showTocButton: "block",
                themes: [
                    {index: 0, value: "default"},
                    {index: 1, value: "metro"},
                    {index: 2, value: "leipzig"},
                    {index: 3, value: "wikipedia"},
                    {index: 4, value: "dilena"},
                    {index: 5, value: "alpha"},
                    {index: 6, value: "uscf"},
                    {index: 7, value: "symbol"}
                ],
            }
        },
        props: {
            data: {
                type: String,
                required: false
            }
        },
        watch: {
            showNotation: function (value) {
                // console.log(value);
                this.cfg.showNotation = value;
                localStorage.setItem("showNotation", value);
                this.cfg.position = this.board.fen();
                this.buildBoard(this.cfg);
            }
        },
        methods: {
            selectTheme(index) {
                // console.log(index);
                for (var i = 0; i < this.themes.length; i++) {
                    if (this.themes[i].index === index) {
                        this.theme = this.themes[i];
                        this.cfg.boardTheme = boardThemes[i];
                        localStorage.setItem("boardTheme", i);
                        this.cfg.position = this.board.fen();
                        this.buildBoard(this.cfg);
                    }
                }
            },
            selectPieceTheme(index) {
                // console.log(index);
                for (var i = 0; i < this.themes.length; i++) {
                    if (this.themes[i].index === index) {
                        this.pieceTheme = this.themes[i];
                        this.cfg.pieceTheme = piecesThemes[i];
                        localStorage.setItem("pieceTheme", i);
                        this.cfg.position = this.board.fen();
                        this.buildBoard(this.cfg);
                    }
                }
            },
            settings() {
                this.activeSettings = true;
            },
            setBookMovesMappings(bookMoves) {
                this.bookMoves = new Map(Object.entries(bookMoves));
                this.lastMove = {game: 0, move: 0, line: 0, nextLines: []};
                this.chess = new Chess();
                this.setFEN("rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1");
                this.lastBookMove = {};
                this.color = "white";
            },
            findMove(game, move, line) {
                var result = null;

                this.bookMoves.forEach(bookMove => {
                    if (bookMove.game === game && bookMove.move === move && line === bookMove.line) {
                        result = bookMove;
                    }
                });

                return result;
            },
            showChapterMenu(event){
                this.$emit("showChapterMenu", event);
            },
            moveForward(event) {

                this.showBoard = 'block';

                if (this.lastBookMove && this.lastBookMove.move >= 0) {

                    if (this.lastBookMove.nextLines && this.lastBookMove.nextLines.length > 0) {
                        this.showLineChooser(event);
                    } else {
                        let move = {
                            game: parseInt(this.lastBookMove.game),
                            move: parseInt(this.lastBookMove.move + 1),
                            line: parseInt(this.lastBookMove.line)
                        };
                        var findMove = this.findMove(move.game, move.move, move.line);

                        if (!findMove) {
                            move.move = move.move + 1;
                            findMove = this.findMove(move.game, move.move, move.line);
                        }

                        let nextMove = move.game + "," + move.move + "," + move.line;
                        this.setMoveCommand(nextMove, true);
                    }
                } else {
                    this.setMoveCommand("0,1,0", true);
                }
            },
            moveBack() {
                // console.log("move forward from " + JSON.stringify(this.lastMove));
                this.$refs.chooseMoveMenu.close();
                this.showBoard = 'block';

                if (this.lastBookMove) {
                    var backMove = {
                        game: this.lastBookMove.game,
                        move: this.lastBookMove.move - 1,
                        line: this.lastBookMove.line
                    };

                    if (backMove.move >= 0) {

                        if (backMove.line > 0 && !this.keyExistsForMove(backMove)) {
                            var line;

                            for (line = backMove.line; line >= 0; line--) {
                                backMove.line = line;

                                if (this.keyExistsForMove(backMove)) {
                                    break;
                                }
                            }
                        }

                        return this.setMoveCommand(this.toMoveCommand(backMove), true);
                    }
                }
            },
            showLineChooser(event) {
                event.stopPropagation();
                event.preventDefault();
                this.nextMoves = this.lastBookMove.nextLines;
                // console.log(this.nextMoves);
                this.$refs.chooseMoveMenu.open(event);
            },
            toMoveCommand(moveLine) {
                return moveLine.game + "," + moveLine.move + "," + moveLine.line;
            },
            chooseMove(move) {
                this.setMoveCommand(this.toMoveCommand(move), true);
                this.$refs.chooseMoveMenu.close();
            },
            handleEnter(move) {
                // console.log(move);
                // console.log(e.keyCode);
                this.$refs.chooseMoveMenu.close();
                this.chooseMove(move);
            },
            flipBoard() {
                this.board.flip();
            },
            hideBoard() {
                this.showBoard = this.showBoard === 'block' ? 'none' : 'block';
                this.$emit("onBoardFenChanged", undefined);
            },
            hideEngine() {
                this.showEngine = this.showEngine === 'block' ? 'none' : 'block';
                this.$emit("onBoardFenChanged", undefined);
                this.$refs.engine.manualEngineSwitch( this.showEngine === 'block' ? "On" : "Off");
            },
            onEngineSetFen(fen) {
                // console.log("on engine set fen event" + fen);
                this.setFEN(fen);
            },
            showToc() {
                this.$emit("onShowToc", undefined);
            },
            clearSelection() {
                if (this.lastBookMove && this.lastBookMove.move > 0) {
                    var lastKey = '[name="' + 'g' +
                        this.lastBookMove.game + 'm' + this.lastBookMove.move + 'v' + this.lastBookMove.line + '"]';
                    // console.log(lastKey);
                    var selectElement = document.querySelector(lastKey);
                    if (selectElement) {
                        selectElement.style.backgroundColor = '';
                    }
                }
            },
            updateSelection(move, scroll) {
                var key = '[name="' + 'g' + move.game + 'm' + move.move + 'v' + move.line + '"]';
                var selectElement = document.querySelector(key);

                if (selectElement) {
                    selectElement.style.backgroundColor = "#ffb0b0";

                    if (scroll) {
                        this.scrollToKey(this.toKey(move));
                    }
                }
            },
            toKey(move) {
                return '[name="' + 'g' + move.game + 'm' + move.move + 'v' + move.line + '"]';
            },
            scrollToView(target, containerEl) {

                // Moved up here for readability:
                var isElement = target && target.nodeType === 1,
                    isNumber = Object.prototype.toString.call(target) === '[object Number]';

                if (isElement) {
                    containerEl.scrollTop = target.offsetTop;
                } else if (isNumber) {
                    containerEl.scrollTop = target;
                } else if (target === 'bottom') {
                    containerEl.scrollTop = containerEl.scrollHeight - containerEl.offsetHeight;
                } else if (target === 'top') {
                    containerEl.scrollTop = 0;
                }

                return true;
            },
            scrollToKey(key) {
                // console.log("scorll called")
                let element = document.querySelector(key);
                scrollIntoView(document.querySelector(key), {
                        time: 500,
                        validTarget: function(target, parentsScrolled){
                            return target.id === "bookHtml";
                        }
                    }
                );
            },
            isInViewport(elem) {
                var distance = elem.getBoundingClientRect();
                return (
                    distance.top >= 0 &&
                    distance.left >= 0 &&
                    distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    distance.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },
            keyExistsForMove(move) {
                var key = '[name="' + 'g' + move.game + 'm' + move.move + 'v' + move.line + '"]';
                var selectElement = document.querySelector(key);
                // console.log("keyExistsForMove");
                // console.log(selectElement);
                return selectElement !== undefined;
            },
            goToGame(gameIndex) {
                // console.log("go to game " + gameIndex);
                this.setMoveCommand()
                let game = this.games[gameIndex];
                let moveNumber = this.getMoveNumber(game.fen) - 1;
                this.chess = new Chess(game.fen);
                this.board.position(game.fen, true);
                this.lastMove = {game: gameIndex, move: moveNumber, line: 0};
                this.$emit("onBoardFenChanged", this.chess.fen());
            },
            scrollToAnchor(key) {
                // console.log("scrollToAnchor  " + key);
                let selectElement = document.querySelector('a[name=' + key + ']');
                let divElem = document.getElementById('bookHtml');
                this.scrollToView(selectElement, divElem);
            },
            setMoveCommand(moveCommand, scroll = false) {
                let parts = moveCommand.split(',');
                let move = {game: parseInt(parts[0]), move: parseInt(parts[1]), line: parseInt(parts[2])};
                this.clearSelection();
                var findMove = this.findMove(move.game, move.move, move.line);

                if (!findMove) {
                    findMove = this.findMove(move.game, move.move - 1, move.line);
                }

                if (findMove) {
                    this.showBoard = "block";
                    this.lastBookMove = findMove;
                    this.setFEN(this.lastBookMove.fen);
                    this.updateSelection(this.lastBookMove, scroll);
                    this.color = this.chess.turn() === 'w' ? "white" : 'black';
                    this.$emit("onBoardFenChanged", this.lastBookMove.fen);
                    this.$refs.engine.setFEN(this.lastBookMove.fen);
                    return this.lastBookMove.fen;
                } else {
                    this.$vs.notify({
                        title: 'Info',
                        text: 'No more moves in line!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                }
            },
            setFEN(fen) {
                this.board.position(fen, true);
                this.chess.load(fen);
            },
            getMoveNumber(fen) {
                let parts = fen.split(" ");

                if (parts[1] === 'w') {
                    return parseInt(parts[5]) * 2 - 1;
                } else {
                    return parseInt(parts[5]) * 2;
                }
            },
            updateLocalStorageHistory(move) {
                if (localStorage.getItem("history")) {
                    var history = JSON.parse(localStorage.getItem("history"));
                    history.lastMove = move;
                    localStorage.setItem("history", JSON.stringify(history));
                }
            },
            onDragStart(source, piece, position, orientation) {
                if (this.chess.game_over() === true ||
                    (this.chess.turn() === 'w' && piece.search(/^b/) !== -1) ||
                    (this.chess.turn() === 'b' && piece.search(/^w/) !== -1)) {
                    return false;
                } else {
                    this.movingPiece = piece;
                }
            },
            onDrop(DRAGGED_PIECE_SOURCE, location, DRAGGED_PIECE,
                   newPosition, oldPosition, CURRENT_ORIENTATION,e) {
                // console.log(e);
                // this.showPromotionChooser(e);
                // console.log('onDrop from ' + source + '->' + target + ",side: " + this.chess.turn() + " ,piece :" + this.movingPiece);
                let source = DRAGGED_PIECE_SOURCE;
                let target = location;
                // console.log('onDrop from ' + source + '->' + target + ",side: " + this.chess.turn() + " ,piece :" + this.movingPiece);

                if (this.isWhitePromotionMove(target)) {
                    this.promotion = {source: source, target: target, side: 'w'};
                } else if (this.isBlackPromotionMove(target)) {
                    this.promotion = {source: source, target: target, side: 'b'};
                } else {
                    let move = this.chess.move({from: source, to: target, promotion: 'q'});
                    if (move === null) return 'snapback';
                }

                this.removeHighlights('white');
                document.querySelector('.square-' + source).classList.add('highlight-white');
                document.querySelector('.square-' + target).classList.add('highlight-white');

            }, onSnapEnd(DRAGGED_PIECE_SOURCE, square, DRAGGED_PIECE,e) {

                let source = DRAGGED_PIECE_SOURCE;
                let target = square;

                // console.log('onSnapEnd ' + source + '->' + target + ",side: " + this.chess.turn() + " ,piece :" + DRAGGED_PIECE);

                if (this.isWhitePromotionMove(target)) {
                    this.promotion = {source: source, target: target, side: 'w'};
                    this.showPromotionChooser(e);
                } else if (this.isBlackPromotionMove(target)) {
                    this.promotion = {source: source, target: target, side: 'b'};
                    this.showPromotionChooser(e);
                }
                else{
                    var fen = this.chess.fen();
                    this.board.position(fen);
                    this.$refs.engine.setFEN(fen);
                    this.color = this.chess.turn() === 'w' ? "white" : 'black';
                    return this.chess.move;
                }
            },
            isWhitePromotionMove(target) {
                return (this.movingPiece === 'wP') && (this.chess.turn() === 'w') && (target === 'a8' || target === 'b8' || target === 'c8'
                    || target === 'd8' || target === 'e8' || target === 'f8' || target === 'g8' || target === 'h8');
            },
            isBlackPromotionMove(target) {
                return this.movingPiece === 'bP' && this.chess.turn() === 'b' && (target === 'a1' || target === 'b1' || target === 'c1'
                    || target === 'd1' || target === 'e1' || target === 'f1' || target === 'g1' || target === 'h1');
            },
            showPromotionChooser(event) {
                event.stopPropagation();
                event.preventDefault();
                this.$refs.promotionMenu.open(event);
            },
            doPromotion(piece) {
                // console.log("doPromotion " + piece + ", " + this.promotion);
                if (this.promotion) {
                    this.chess.move({from: this.promotion.source, to: this.promotion.target, promotion: piece});
                    this.board.position(this.chess.fen(), true);
                    this.$refs.engine.setFEN(this.chess.fen());
                    this.color = this.chess.turn() === 'w' ? "white" : 'black';
                    setTimeout(this.board.resize, 200);
                }
            },
            removeHighlights(color) {
                document.getElementById("myBoard").querySelectorAll('.square-55d63').forEach(value => {
                    value.classList.remove('highlight-' + color);
                })
            },
            buildBoard(cfg) {
                // console.log(cfg);
                this.board = Chessboard('myBoard', cfg);
                this.chess = new Chess(cfg.fen);
                let v = this.board;
                window.addEventListener('resize', function () {
                    // console.log("resize");
                    v.resize();
                });
            }
        },
        mounted() {
            let boardThemeIndex = localStorage.getItem("boardTheme") ? parseInt(localStorage.getItem("boardTheme")) : 0;
            let pieceThemeIndex = localStorage.getItem("pieceTheme") ? parseInt(localStorage.getItem("pieceTheme")) : 0;

            for (var x = 0; x < this.themes.length; x++) {

                if (this.themes[x].index === boardThemeIndex) {
                    this.theme = this.themes[x];
                }

                if (this.themes[x].index === pieceThemeIndex) {
                    this.pieceTheme = this.themes[x];
                }
            }

            this.showNotation = localStorage.getItem("showNotation") === 'true';

            var temp = localStorage.getItem("showNotation") ? localStorage.getItem("showNotation") === true : false;
            // console.log(localStorage.getItem("showNotation"));

            this.cfg = {
                showNotation: this.showNotation,
                draggable: true,
                position: 'start',
                pieceTheme: piecesThemes[pieceThemeIndex],
                locale: 'en',
                orientation: 'white',
                playerColor: 'w',
                onDragStart: this.onDragStart,
                onDrop: this.onDrop,
                onSnapEnd: this.onSnapEnd,
                boardTheme: boardThemes[boardThemeIndex],
            };

            this.buildBoard(this.cfg);

            let tempThis = this;
            // this.$mousetrap.bind('right', function (e) {
            //     tempThis.moveForward(e);
            // });
            //
            // this.$mousetrap.bind('left', function (e) {
            //     tempThis.moveBack();
            // });
        },
        created() {
        },
    }
</script>
<style>
  .drop-icon {
    font-size: large;
  }

  .drop-item {
    color: black;
    padding-left: 10px;
    font-weight: bold;
    font-size: large;
  }

  .v-context {
    background-color: #fff;
    background-clip: padding-box;
    border-radius: .25rem;
    border: 1px solid rgba(0, 0, 0, .15);
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);
    display: block;
    margin: 0;
    padding: 10px 0;
    min-width: 10rem;
    z-index: 1500;
    position: fixed;
    list-style: none;
    box-sizing: border-box
  }

  .v-context > li {
    margin: 0
  }

  .v-context > li > a {
    display: block;
    padding: .5rem 1.5rem;
    font-weight: 400;
    color: #212529;
    text-decoration: none;
    white-space: nowrap;
    background-color: transparent;
    border: 0
  }

  .v-context > li > a:focus, .v-context > li > a:hover {
    text-decoration: none;
    color: #212529;
    background-color: #f8f9fa
  }

  .v-context:focus, .v-context > li > a:focus {
    outline: 0
  }

  .highlight-white {
    -webkit-box-shadow: inset 0 0 3px 3px yellow;
    -moz-box-shadow: inset 0 0 3px 3px yellow;
    box-shadow: inset 0 0 3px 3px yellow;
  }

  .highlight-black {
    -webkit-box-shadow: inset 0 0 3px 3px blue;
    -moz-box-shadow: inset 0 0 3px 3px blue;
    box-shadow: inset 0 0 3px 3px blue;
  }

  /* clearfix */
  .clearfix-7da63 {
    clear: both;
  }

  /* board */
  .board-b72b1 {
    border: 2px solid #404040;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
  }

  /* square */
  .square-55d63 {
    float: left;
    position: relative;

    /* disable any native browser highlighting */
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* highlighted square */
  .highlight1-32417, .highlight2-9c5d2 {
    -webkit-box-shadow: inset 0 0 3px 3px yellow;
    -moz-box-shadow: inset 0 0 3px 3px yellow;
    box-shadow: inset 0 0 3px 3px yellow;
  }

  /* notation */
  .notation-322f9 {
    cursor: default;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    position: absolute;
  }

  .alpha-d2270 {
    bottom: 1px;
    right: 3px;
  }

  .numeric-fc462 {
    top: 2px;
    left: 2px;
  }


</style>
